// extracted by mini-css-extract-plugin
export default {"count":"dashboard-metrics_count__xGDXL","title":"dashboard-metrics_title__aTk3Y"};